const privateEmailDomains = [
  "gmail.com",
  "googlemail.com",
  "outlook.com",
  "hotmail.com",
  "live.com",
  "msn.com",
  "yahoo.com",
  "ymail.com",
  "rocketmail.com",
  "aol.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "mail.com",
  "gmx.com",
  "gmx.net",
  "mail.ru",
  "yandex.ru",
  "yandex.com",
  "rambler.ru",
  "163.com",
  "126.com",
  "qq.com",
  "sina.com",
  "sina.cn",
  "sohu.com",
  "tom.com",
  "yeah.net",
  "web.de",
  "gmx.de",
  "t-online.de",
  "orange.fr",
  "sfr.fr",
  "free.fr",
  "laposte.net",
  "libero.it",
  "alice.it",
  "tin.it",
  "wp.pl",
  "onet.pl",
  "o2.pl",
  "interia.pl",
  "seznam.cz",
  "centrum.cz",
  "rediffmail.com",
  "naver.com",
  "daum.net",
  "hanmail.net",
  "nate.com",
  "comcast.net",
  "att.net",
  "sbcglobal.net",
  "verizon.net",
  "earthlink.net",
  "cox.net",
  "charter.net",
  "bellsouth.net",
  "pacbell.net",
  "ameritech.net",
  "optimum.net",
  "optonline.net",
  "windstream.net",
  "centurylink.net",
  "roadrunner.com",
  "twc.com",
  "btinternet.com",
  "talktalk.net",
  "sky.com",
  "virginmedia.com",
  "ntlworld.com",
  "blueyonder.co.uk",
  "freeserve.co.uk",
  "wanadoo.co.uk",
  "telus.net",
  "shaw.ca",
  "rogers.com",
  "bell.net",
  "sympatico.ca",
  "bigpond.com",
  "bigpond.net.au",
  "optusnet.com.au",
  "iinet.net.au",
  "xtra.co.nz",
  "protonmail.com",
  "proton.me",
  "tutanota.com",
  "tuta.io",
  "zoho.com",
  "zohomail.com",
  "hushmail.com",
  "inbox.com",
  "lycos.com",
  "excite.com",
  "europe.com",
  "usa.com",
  "dr.com",
  "engineer.com",
  "consultant.com",
  "myself.com",
  "post.com",
  "email.com",
  "iname.com",
  "netscape.net",
  "aim.com",
  "yahoo.co.uk",
  "yahoo.fr",
  "yahoo.de",
  "yahoo.ca",
  "yahoo.co.in",
  "hotmail.co.uk",
  "hotmail.fr",
  "live.co.uk",
  "live.ca",
  "windowslive.com"
];

export const checkUserType = domain => {
  if (privateEmailDomains.includes(domain)) {
    return "private";
  }
  return "business";
};
